import React from 'react';
import { Link } from 'react-router-dom';
import { EventData, track } from '@/helpers/analytics';

interface ActionLinkProps {
    to: string;
    children: React.ReactNode;
    variant?: 'solid' | 'outline';
    size?: 'md' | 'sm';
    event?: string;
    eventData?: EventData;
}

const ActionLink: React.FC<ActionLinkProps> = ({ to, children, variant = 'outline', size = 'md', event, eventData }) => {
    const sizeClass = size === 'sm' ? 'px-4 py-1.5 text-sm' : 'px-5 py-2.5';
    const style = variant === 'solid'
        ? 'border-2 border-primary bg-primary text-textColor hover:border-primaryDark hover:bg-primaryDark'
        : 'border-2 border-primary text-textColor hover:bg-primaryLight';

    return (
        <Link
            to={to}
            onClick={event ? () => track(event, eventData) : undefined}
            className={`inline-flex items-center justify-center gap-2 rounded-full font-semibold ${sizeClass} transition ${style}`}
        >
            {children}
        </Link>
    );
};

export default ActionLink;
